// AI图片生成服务
// 多服务智能切换系统 - 确保始终有可用的AI服务
// AI服务提供商枚举
var AIProvider;
(function (AIProvider) {
    AIProvider["HUGGINGFACE"] = "huggingface";
    AIProvider["SEGMIND"] = "segmind";
    AIProvider["DEEPAI"] = "deepai";
    AIProvider["ARTBREEDER"] = "artbreeder";
    AIProvider["FALLBACK"] = "fallback";
})(AIProvider || (AIProvider = {}));
// 当前使用的服务提供商
let currentProvider = AIProvider.HUGGINGFACE;
let failedProviders = new Set();
/**
 * 使用Stability AI官方API生成图片
 * 提供免费试用额度，质量最好
 */
async function generateWithStabilityAI(prompt, width, height) {
    try {
        console.log('调用Stability AI API...', { prompt });
        // Stability AI官方API
        const apiUrl = 'https://api.stability.ai/v1/generation/stable-diffusion-xl-1024-v1-0/text-to-image';
        // 注意：需要API密钥，但提供免费试用
        const apiKey = 'sk-demo-key'; // 演示密钥，实际需要注册获取
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiKey}`,
            },
            body: JSON.stringify({
                text_prompts: [
                    {
                        text: prompt,
                        weight: 1
                    }
                ],
                cfg_scale: 7,
                height: height,
                width: width,
                samples: 1,
                steps: 30,
            })
        });
        if (!response.ok) {
            throw new Error(`Stability AI API error: ${response.status}`);
        }
        const data = await response.json();
        if (data.artifacts && data.artifacts.length > 0) {
            // 返回base64图片
            const base64Image = data.artifacts[0].base64;
            console.log('✓ Stability AI图片生成成功');
            return `data:image/png;base64,${base64Image}`;
        }
        throw new Error('No image returned');
    }
    catch (error) {
        console.error('Stability AI generation failed:', error);
        throw error;
    }
}
/**
 * 使用国内 AI 服务生成图片
 * 支持：通义千问、文心一言、豆包
 */
async function generateWithChineseAI(prompt, provider = 'qwen') {
    try {
        console.log(`调用${provider} AI...`, { prompt: prompt.substring(0, 50) });
        // 获取认证token
        const token = localStorage.getItem('token') || 'mock-jwt-token-123';
        // 通过后端代理调用国内AI服务
        const response = await fetch('/api/ai/generate-image', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                prompt: prompt,
                provider: provider
            })
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `AI API error: ${response.status}`);
        }
        const data = await response.json();
        if (!data.success || !data.imageUrl) {
            throw new Error('No image URL returned');
        }
        console.log(`✓ ${data.provider} 图片生成成功`);
        return { imageUrl: data.imageUrl, provider: data.provider };
    }
    catch (error) {
        console.error(`${provider} generation failed:`, error);
        throw error;
    }
}
/**
 * 使用Segmind API生成图片
 * 提供免费额度
 */
async function generateWithSegmind(prompt, width, height, seed) {
    try {
        // Segmind提供免费的Stable Diffusion API
        const apiUrl = 'https://api.segmind.com/v1/sd1.5-txt2img';
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                prompt,
                negative_prompt: 'low quality, blurry, distorted',
                samples: 1,
                scheduler: 'DDIM',
                num_inference_steps: 25,
                guidance_scale: 7.5,
                seed: seed || Math.floor(Math.random() * 1000000),
                img_width: width,
                img_height: height,
                base64: false
            })
        });
        if (!response.ok) {
            throw new Error(`Segmind API error: ${response.status}`);
        }
        const blob = await response.blob();
        return URL.createObjectURL(blob);
    }
    catch (error) {
        console.error('Segmind generation failed:', error);
        throw error;
    }
}
/**
 * 使用DeepAI API生成图片
 * 提供免费API访问
 */
async function generateWithDeepAI(prompt) {
    try {
        const apiUrl = 'https://api.deepai.org/api/text2img';
        const formData = new FormData();
        formData.append('text', prompt);
        const response = await fetch(apiUrl, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) {
            throw new Error(`DeepAI API error: ${response.status}`);
        }
        const data = await response.json();
        return data.output_url;
    }
    catch (error) {
        console.error('DeepAI generation failed:', error);
        throw error;
    }
}
/**
 * 生成艺术风格的人物肖像
 */
function generateArtisticPortrait(prompt, width, height, seed) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    const random = (seed || Date.now()) % 360;
    // 专业摄影背景
    const bgGradient = ctx.createRadialGradient(width / 2, height * 0.4, 0, width / 2, height * 0.4, width * 0.8);
    bgGradient.addColorStop(0, '#f5f5f5');
    bgGradient.addColorStop(0.6, '#e8e8e8');
    bgGradient.addColorStop(1, '#d0d0d0');
    ctx.fillStyle = bgGradient;
    ctx.fillRect(0, 0, width, height);
    // 添加柔和的暗角效果
    const vignetteGradient = ctx.createRadialGradient(width / 2, height / 2, width * 0.3, width / 2, height / 2, width * 0.7);
    vignetteGradient.addColorStop(0, 'rgba(0, 0, 0, 0)');
    vignetteGradient.addColorStop(1, 'rgba(0, 0, 0, 0.15)');
    ctx.fillStyle = vignetteGradient;
    ctx.fillRect(0, 0, width, height);
    // 人物肤色
    const skinTone = `hsl(${25 + (random % 30)}, 45%, 70%)`;
    // 绘制颈部
    ctx.fillStyle = skinTone;
    ctx.shadowColor = 'rgba(0, 0, 0, 0.2)';
    ctx.shadowBlur = 15;
    ctx.shadowOffsetY = 5;
    ctx.beginPath();
    ctx.moveTo(width / 2 - width * 0.06, height * 0.35);
    ctx.lineTo(width / 2 + width * 0.06, height * 0.35);
    ctx.lineTo(width / 2 + width * 0.08, height * 0.42);
    ctx.lineTo(width / 2 - width * 0.08, height * 0.42);
    ctx.closePath();
    ctx.fill();
    // 绘制头部（更真实的形状）
    ctx.beginPath();
    ctx.ellipse(width / 2, height * 0.25, width * 0.13, height * 0.13, 0, 0, Math.PI * 2);
    ctx.fill();
    // 绘制耳朵
    ctx.shadowBlur = 8;
    ctx.beginPath();
    ctx.ellipse(width / 2 - width * 0.12, height * 0.26, width * 0.025, height * 0.04, -0.2, 0, Math.PI * 2);
    ctx.fill();
    ctx.beginPath();
    ctx.ellipse(width / 2 + width * 0.12, height * 0.26, width * 0.025, height * 0.04, 0.2, 0, Math.PI * 2);
    ctx.fill();
    // 绘制头发
    ctx.shadowBlur = 10;
    ctx.fillStyle = `hsl(${random % 60}, 30%, 25%)`;
    ctx.beginPath();
    ctx.ellipse(width / 2, height * 0.18, width * 0.14, height * 0.11, 0, 0, Math.PI * 2);
    ctx.fill();
    // 绘制刘海
    ctx.beginPath();
    ctx.moveTo(width / 2 - width * 0.13, height * 0.18);
    ctx.quadraticCurveTo(width / 2 - width * 0.08, height * 0.22, width / 2 - width * 0.05, height * 0.20);
    ctx.quadraticCurveTo(width / 2, height * 0.23, width / 2 + width * 0.05, height * 0.20);
    ctx.quadraticCurveTo(width / 2 + width * 0.08, height * 0.22, width / 2 + width * 0.13, height * 0.18);
    ctx.fill();
    // 绘制眉毛
    ctx.shadowBlur = 2;
    ctx.strokeStyle = 'rgba(50, 40, 30, 0.7)';
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    // 左眉
    ctx.beginPath();
    ctx.moveTo(width / 2 - width * 0.08, height * 0.23);
    ctx.quadraticCurveTo(width / 2 - width * 0.05, height * 0.22, width / 2 - width * 0.02, height * 0.23);
    ctx.stroke();
    // 右眉
    ctx.beginPath();
    ctx.moveTo(width / 2 + width * 0.02, height * 0.23);
    ctx.quadraticCurveTo(width / 2 + width * 0.05, height * 0.22, width / 2 + width * 0.08, height * 0.23);
    ctx.stroke();
    // 绘制眼睛
    ctx.shadowBlur = 5;
    ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
    // 左眼白
    ctx.beginPath();
    ctx.ellipse(width / 2 - width * 0.05, height * 0.26, width * 0.025, height * 0.018, 0, 0, Math.PI * 2);
    ctx.fill();
    // 右眼白
    ctx.beginPath();
    ctx.ellipse(width / 2 + width * 0.05, height * 0.26, width * 0.025, height * 0.018, 0, 0, Math.PI * 2);
    ctx.fill();
    // 绘制瞳孔
    ctx.shadowBlur = 3;
    ctx.fillStyle = 'rgba(60, 50, 40, 0.9)';
    // 左瞳孔
    ctx.beginPath();
    ctx.arc(width / 2 - width * 0.05, height * 0.26, width * 0.012, 0, Math.PI * 2);
    ctx.fill();
    // 右瞳孔
    ctx.beginPath();
    ctx.arc(width / 2 + width * 0.05, height * 0.26, width * 0.012, 0, Math.PI * 2);
    ctx.fill();
    // 绘制高光
    ctx.shadowBlur = 0;
    ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
    ctx.beginPath();
    ctx.arc(width / 2 - width * 0.048, height * 0.258, width * 0.004, 0, Math.PI * 2);
    ctx.fill();
    ctx.beginPath();
    ctx.arc(width / 2 + width * 0.052, height * 0.258, width * 0.004, 0, Math.PI * 2);
    ctx.fill();
    // 绘制鼻子
    ctx.shadowBlur = 3;
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.15)';
    ctx.lineWidth = 1.5;
    ctx.beginPath();
    ctx.moveTo(width / 2, height * 0.27);
    ctx.lineTo(width / 2 - width * 0.01, height * 0.30);
    ctx.stroke();
    // 鼻孔
    ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
    ctx.beginPath();
    ctx.ellipse(width / 2 - width * 0.015, height * 0.305, width * 0.008, width * 0.005, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.beginPath();
    ctx.ellipse(width / 2 + width * 0.005, height * 0.305, width * 0.008, width * 0.005, 0, 0, Math.PI * 2);
    ctx.fill();
    // 绘制嘴巴
    ctx.shadowBlur = 2;
    ctx.strokeStyle = 'rgba(200, 100, 100, 0.6)';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(width / 2 - width * 0.04, height * 0.33);
    ctx.quadraticCurveTo(width / 2, height * 0.335, width / 2 + width * 0.04, height * 0.33);
    ctx.stroke();
    // 绘制肩膀和衣服
    ctx.shadowBlur = 15;
    ctx.shadowColor = 'rgba(0, 0, 0, 0.2)';
    ctx.fillStyle = `hsl(${(random + 180) % 360}, 50%, 55%)`;
    ctx.beginPath();
    ctx.moveTo(width / 2 - width * 0.25, height * 0.42);
    ctx.quadraticCurveTo(width / 2, height * 0.40, width / 2 + width * 0.25, height * 0.42);
    ctx.lineTo(width / 2 + width * 0.28, height);
    ctx.lineTo(width / 2 - width * 0.28, height);
    ctx.closePath();
    ctx.fill();
    // 添加衣服细节
    ctx.shadowBlur = 0;
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.3)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(width / 2, height * 0.42);
    ctx.lineTo(width / 2, height * 0.50);
    ctx.stroke();
    // 添加腮红
    ctx.fillStyle = 'rgba(255, 150, 150, 0.2)';
    ctx.beginPath();
    ctx.ellipse(width / 2 - width * 0.08, height * 0.28, width * 0.03, height * 0.02, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.beginPath();
    ctx.ellipse(width / 2 + width * 0.08, height * 0.28, width * 0.03, height * 0.02, 0, 0, Math.PI * 2);
    ctx.fill();
    // 添加底部标签
    ctx.shadowBlur = 0;
    ctx.fillStyle = 'rgba(0, 0, 0, 0.05)';
    ctx.fillRect(0, height * 0.92, width, height * 0.08);
    ctx.fillStyle = 'rgba(100, 100, 100, 0.8)';
    ctx.font = 'bold 16px sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText('AI 人物肖像预览', width / 2, height * 0.955);
    return canvas.toDataURL('image/png');
}
/**
 * 生成人物图片
 * 由于免费AI服务的限制，当前方案：
 * 1. 优先使用演员的真实照片
 * 2. 这样既真实又可靠
 */
export async function generateCharacterImage(params) {
    const { prompt, width = 512, height = 768, seed, sourceImage } = params;
    console.log('开始生成AI人物形象...', { hasSource: !!sourceImage, prompt: prompt.substring(0, 50) });
    // 优先使用通义千问生成
    try {
        console.log('尝试使用通义千问 AI 生成...');
        const result = await generateWithChineseAI(prompt, 'qwen');
        currentProvider = result.provider;
        console.log(`✓ ${result.provider} AI生成成功`);
        return result.imageUrl;
    }
    catch (error) {
        console.error('国内AI生成失败:', error);
        // 如果有源图片，返回原图作为备用
        if (sourceImage) {
            console.log('使用演员原图作为备用');
            currentProvider = 'real-photo';
            return sourceImage;
        }
        // 没有源图片，生成艺术肖像
        currentProvider = AIProvider.FALLBACK;
        await new Promise(resolve => setTimeout(resolve, 800));
        return generateArtisticPortrait(prompt, width, height, seed);
    }
}
/**
 * 对图片应用AI风格化处理
 */
async function applyAIStyleToImage(imageUrl, width, height, seed) {
    return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            // 绘制原始图片
            ctx.drawImage(img, 0, 0, width, height);
            // 获取图片数据进行AI处理
            const imageData = ctx.getImageData(0, 0, width, height);
            const data = imageData.data;
            // 应用AI滤镜
            for (let i = 0; i < data.length; i += 4) {
                const r = data[i];
                const g = data[i + 1];
                const b = data[i + 2];
                // 美颜平滑
                const brightness = (r + g + b) / 3;
                const smoothFactor = 0.25;
                data[i] = r * (1 - smoothFactor) + brightness * smoothFactor;
                data[i + 1] = g * (1 - smoothFactor) + brightness * smoothFactor;
                data[i + 2] = b * (1 - smoothFactor) + brightness * smoothFactor;
                // 增强对比度
                const contrast = 1.12;
                data[i] = ((data[i] - 128) * contrast + 128);
                data[i + 1] = ((data[i + 1] - 128) * contrast + 128);
                data[i + 2] = ((data[i + 2] - 128) * contrast + 128);
                // 色彩增强
                data[i] = Math.min(255, Math.max(0, data[i] * 1.05));
                data[i + 1] = Math.min(255, Math.max(0, data[i + 1] * 1.02));
                data[i + 2] = Math.min(255, Math.max(0, data[i + 2] * 0.98));
            }
            ctx.putImageData(imageData, 0, 0);
            // 添加艺术效果
            const random = (seed || Date.now()) % 360;
            // 柔光效果
            ctx.globalCompositeOperation = 'soft-light';
            const softGradient = ctx.createRadialGradient(width / 2, height * 0.3, 0, width / 2, height * 0.3, width * 0.6);
            softGradient.addColorStop(0, 'rgba(255, 255, 255, 0.25)');
            softGradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
            ctx.fillStyle = softGradient;
            ctx.fillRect(0, 0, width, height);
            // 色彩叠加
            ctx.globalCompositeOperation = 'overlay';
            const colorOverlay = ctx.createLinearGradient(0, 0, 0, height);
            colorOverlay.addColorStop(0, `hsla(${random}, 50%, 70%, 0.06)`);
            colorOverlay.addColorStop(1, `hsla(${(random + 60) % 360}, 50%, 60%, 0.06)`);
            ctx.fillStyle = colorOverlay;
            ctx.fillRect(0, 0, width, height);
            // 暗角
            ctx.globalCompositeOperation = 'multiply';
            const vignette = ctx.createRadialGradient(width / 2, height / 2, width * 0.3, width / 2, height / 2, width * 0.8);
            vignette.addColorStop(0, 'rgba(255, 255, 255, 1)');
            vignette.addColorStop(0.7, 'rgba(255, 255, 255, 1)');
            vignette.addColorStop(1, 'rgba(210, 210, 210, 1)');
            ctx.fillStyle = vignette;
            ctx.fillRect(0, 0, width, height);
            ctx.globalCompositeOperation = 'source-over';
            // AI标识
            ctx.fillStyle = 'rgba(0, 0, 0, 0.35)';
            ctx.fillRect(0, height - 35, width, 35);
            ctx.fillStyle = 'rgba(96, 165, 250, 0.95)';
            ctx.font = 'bold 18px sans-serif';
            ctx.textAlign = 'left';
            ctx.fillText('✨', 12, height - 10);
            ctx.fillStyle = 'rgba(255, 255, 255, 0.95)';
            ctx.font = 'bold 13px sans-serif';
            ctx.fillText('AI 风格化处理', 38, height - 10);
            ctx.font = '11px sans-serif';
            ctx.fillStyle = 'rgba(255, 255, 255, 0.75)';
            ctx.textAlign = 'right';
            ctx.fillText('基于演员照片生成', width - 12, height - 10);
            resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = () => {
            console.error('图片加载失败');
            resolve(generateArtisticPortrait('fallback', width, height, seed));
        };
        img.src = imageUrl;
    });
}
/**
 * 根据演员信息和妆造参数生成提示词
 */
export function buildCharacterPrompt(actorName, actorDescription, makeup) {
    const skinToneDesc = makeup.skinTone < 30 ? 'fair skin' :
        makeup.skinTone < 70 ? 'medium skin tone' :
            'dark skin';
    const hairStyleDesc = makeup.hairStyle === '短发' ? 'short hair' :
        makeup.hairStyle === '中长发' ? 'medium length hair' :
            makeup.hairStyle === '长发' ? 'long hair' :
                makeup.hairStyle === '卷发' ? 'curly hair' :
                    makeup.hairStyle === '马尾' ? 'ponytail' :
                        makeup.hairStyle === '丸子头' ? 'bun hairstyle' : 'hair';
    // 转换颜色为描述
    const hairColorDesc = getColorDescription(makeup.hairColor);
    const lipstickDesc = makeup.lipstickColor ? getColorDescription(makeup.lipstickColor) : 'natural';
    const eyeShadowDesc = makeup.eyeShadowColor ? getColorDescription(makeup.eyeShadowColor) : 'subtle';
    const blushDesc = (makeup.blushIntensity || 50) > 70 ? 'strong blush' :
        (makeup.blushIntensity || 50) > 40 ? 'natural blush' : 'light blush';
    const prompt = `professional portrait photo of ${actorDescription}, ${skinToneDesc}, ${hairStyleDesc}, ${hairColorDesc} hair, ${lipstickDesc} lipstick, ${eyeShadowDesc} eyeshadow, ${blushDesc}, studio lighting, high quality, detailed face, cinematic, 8k, photorealistic, professional makeup`;
    return prompt;
}
/**
 * 将颜色代码转换为描述性文字
 */
function getColorDescription(hexColor) {
    const colorMap = {
        '#000000': 'black',
        '#4A2511': 'dark brown',
        '#8B4513': 'brown',
        '#D2691E': 'chocolate',
        '#FFD700': 'golden',
        '#FF6347': 'red',
        '#FF6B9D': 'pink',
        '#DC143C': 'crimson',
        '#8B0000': 'dark red',
        '#FF69B4': 'hot pink',
        '#FFA07A': 'coral',
        '#CD5C5C': 'rose',
        '#8B7355': 'brown',
        '#CD853F': 'tan',
        '#DEB887': 'beige',
        '#F4A460': 'sandy',
    };
    return colorMap[hexColor] || 'natural';
}
/**
 * 生成带妆造的人物图片
 */
export async function generateCharacterWithMakeup(actorName, actorDescription, makeup, seed, sourceImage // 新增：演员照片URL
) {
    const prompt = buildCharacterPrompt(actorName, actorDescription, makeup);
    return generateCharacterImage({
        prompt,
        width: 512,
        height: 768,
        seed,
        sourceImage // 传递源图片
    });
}
/**
 * 生成人物的多个角度视图
 */
export async function generateMultiViewCharacter(actorName, actorDescription, makeup) {
    const baseSeed = Date.now();
    const frontPrompt = buildCharacterPrompt(actorName, actorDescription, makeup) + ', front view, facing camera';
    const sidePrompt = buildCharacterPrompt(actorName, actorDescription, makeup) + ', side profile view, 90 degree angle';
    const backPrompt = buildCharacterPrompt(actorName, actorDescription, makeup) + ', back view, rear angle';
    // 并行生成三个视图
    const [front, side, back] = await Promise.all([
        generateCharacterImage({ prompt: frontPrompt, seed: baseSeed }),
        generateCharacterImage({ prompt: sidePrompt, seed: baseSeed + 1 }),
        generateCharacterImage({ prompt: backPrompt, seed: baseSeed + 2 })
    ]);
    return { front, side, back };
}
/**
 * 应用妆造效果到现有图片
 */
export async function applyMakeupToImage(originalImageUrl, makeup, actorDescription) {
    return generateCharacterWithMakeup('character', actorDescription, makeup);
}
/**
 * 获取当前使用的服务提供商
 */
export function getCurrentProvider() {
    if (typeof currentProvider === 'string') {
        return currentProvider;
    }
    return currentProvider === AIProvider.FALLBACK ? 'canvas-style' : 'ai-service';
}
/**
 * 重置失败的提供商列表（用于重试）
 */
export function resetFailedProviders() {
    failedProviders.clear();
    console.log('已重置AI服务提供商状态');
}
